module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.5de3f070.png";